module.exports = __webpack_public_path__ + "static/media/blog_img3.38323bad.png";